/**
 * Banner de trial (diseño Alta.dc.html, pantalla 7).
 *
 * Solo aparece si el tenant tiene trial_ends_at (NULL = sin límite).
 * Última semana: variante de aviso. Sin precio decidido, el CTA es hablar.
 */
import { useEffect, useState } from 'react';
import { getTenantStatus, TenantStatus } from '../../services/apiClient';
import { Icon } from './Icon';

const CACHE_KEY = 'kakuat-tenant-status';
const CACHE_MS = 10 * 60 * 1000;

async function fetchStatus(): Promise<TenantStatus | null> {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (raw) {
      const { at, data } = JSON.parse(raw) as { at: number; data: TenantStatus };
      if (Date.now() - at < CACHE_MS) return data;
    }
  } catch {
    /* caché rota: se pide de nuevo */
  }
  try {
    const data = await getTenantStatus();
    sessionStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), data }));
    return data;
  } catch {
    return null;
  }
}

export function TrialBanner() {
  const [status, setStatus] = useState<TenantStatus | null>(null);

  useEffect(() => {
    fetchStatus().then(setStatus);
  }, []);

  const days = status?.trial_days_left;
  if (days == null) return null;

  const lastWeek = days <= 7;
  const mailto =
    'mailto:kakuat@kakuat.com?subject=' +
    encodeURIComponent(`Activar plan Kakuat — ${status?.name ?? ''}`);

  if (lastWeek) {
    return (
      <div className="flex items-center gap-3.5 bg-warn-soft border border-warn rounded-2xl px-4 py-3.5 animate-rise">
        <span className="w-10 h-10 rounded-xl bg-canvas grid place-items-center flex-none text-warn">
          <Icon name="alert" size={20} strokeWidth={1.9} />
        </span>
        <div className="flex-1 min-w-0">
          <div className="font-bold text-[14.5px] text-warn">
            Última semana: {days === 0 ? 'la prueba termina hoy' : `quedan ${days} día${days === 1 ? '' : 's'} de prueba`}
          </div>
          <div className="text-[13px] text-ink-2">Activa un plan para que tu equipo no deje de fichar.</div>
        </div>
        <a
          href={mailto}
          className="flex-none h-[38px] px-4 rounded-[10px] bg-warn text-white font-bold text-[13.5px] grid place-items-center"
        >
          Activar plan
        </a>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3.5 bg-surface border border-line-strong rounded-2xl px-4 py-3.5 animate-rise">
      <span className="w-10 h-10 rounded-xl bg-brand-soft grid place-items-center flex-none text-brand">
        <Icon name="clock" size={20} strokeWidth={1.8} />
      </span>
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-[14.5px]">Prueba gratis · quedan {days} días</div>
        <div className="text-[13px] text-ink-2">Sin tarjeta. Cuando quieras, activa un plan.</div>
      </div>
      <a
        href={mailto}
        className="flex-none h-[38px] px-4 rounded-[10px] bg-brand text-on-brand font-semibold text-[13.5px] grid place-items-center"
      >
        Ver planes
      </a>
    </div>
  );
}
